import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullhorn, faHandHoldingHeart, faUsers, faMedkit, faDollarSign } from '@fortawesome/free-solid-svg-icons';

const Services = () => {
    const governmentSchemes = [
        {
            id: "01",
            title: "National Sickle Cell Anaemia Elimination Mission",
            description: "Aims to eliminate Sickle Cell Anaemia by 2047 through screening, counseling, and comprehensive care.",
            image: faBullhorn,
            color: "blue",
            detailDesc: "Launched to address the significant health burden of sickle cell disease, this mission focuses on universal screening of individuals up to 40 years in affected tribal areas, pre-marital and pre-conceptional genetic counseling, and strengthening healthcare infrastructure for management and treatment."
        },
        {
            id: "02",
            title: "Rashtriya Bal Swasthya Karyakram (RBSK)",
            description: "Provides early identification and intervention for children, including screening for genetic disorders like SCD.",
            image: faUsers,
            color: "purple",
            detailDesc: "RBSK focuses on early detection and management of 4 ‘D’s viz. Defects at birth, Deficiencies, Diseases, Development delays including disability. Sickle Cell Disease is covered under this program for early screening and linkage to care."
        },
        {
            id: "03",
            title: "Ayushman Bharat - PMJAY",
            description: "Offers health insurance coverage for secondary and tertiary care hospitalization, including SCD treatments.",
            image: faHandHoldingHeart,
            color: "green",
            detailDesc: "This flagship scheme provides a health cover of Rs. 5 lakhs per family per year for secondary and tertiary care hospitalization to over 10 crore poor and vulnerable families. It helps in mitigating catastrophic expenditure for SCD related hospitalizations."
        },
        {
            id: "04",
            title: "National Health Mission (NHM) Support",
            description: "NHM supports states in strengthening healthcare for screening, diagnosis, and management of SCD.",
            image: faMedkit,
            color: "amber",
            detailDesc: "Under NHM, financial and technical support is provided to States/UTs for strengthening their healthcare systems, including for prevention and management of sickle cell disease through early screening, awareness generation, and ensuring availability of necessary treatment protocols."
        }
    ];

    const getIconColor = (color) => {
        switch (color) {
            case "blue": return "text-blue-500 bg-blue-100";
            case "purple": return "text-purple-500 bg-purple-100";
            case "green": return "text-green-500 bg-green-100";
            case "amber": return "text-amber-500 bg-amber-100";
            default: return "text-blue-500 bg-blue-100";
        }
    };

    return (
        <div id="government-schemes" className="py-20 bg-gradient-to-b from-white to-blue-50">
            <div className="container mx-auto px-4">
                <div className="text-center mb-16">
                    <span className="text-primary-600 font-semibold">Government Support</span>
                    <h2 className="text-4xl font-bold text-gray-800 mt-2">
                        Government Schemes for Sickle Cell Disease
                    </h2>
                    <div className="w-24 h-1 bg-primary-600 mx-auto my-6"></div>
                    <p className="max-w-2xl mx-auto text-gray-600 text-lg">
                        Learn about various government initiatives aimed at supporting individuals with Sickle Cell Disease through awareness, screening, and healthcare services.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {governmentSchemes.map(scheme => (
                        <div
                            key={scheme.id}
                            className="bg-white rounded-xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-2"
                        >
                            <div className={`p-6 flex flex-col items-center text-center`}>
                                <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 ${getIconColor(scheme.color)}`}>
                                    <FontAwesomeIcon icon={scheme.image} className="text-2xl" />
                                </div>

                                <h3 className="text-xl font-bold text-gray-800 mb-3">
                                    {scheme.title}
                                </h3>

                                <p className="text-gray-600 mb-6">
                                    {scheme.description}
                                </p>


                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Services;
